import arrowDownIcon from '../../assets/icons/arrow-down.svg'

const ArrowDownIcon = () => (
    <img src={arrowDownIcon} alt="ArrowDown" />
  );
  
  export default ArrowDownIcon;